import script from "./AuctionItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionItemList.vue?vue&type=script&setup=true&lang=js"

import "./AuctionItemList.vue?vue&type=style&index=0&id=08a2189e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a2189e"]])

export default __exports__